export default __webpack_public_path__ + "static/media/auteuil10.4f0f4ce1.jpg";